<template>
  <v-card style="border: 0px; margin-top: 0px !important">
    <v-form v-model="employee.valid">
      <v-container class="pt-0" fluid>
        <v-layout>
          <v-flex md6 sm6 xs6>
            <remote-autocomplete
              :rules="[(v) => !!v || ` 所属会社 is required`]"
              @change="changeCompany"
              @item="(item) => (companyType = item && item.type)"
              label="所属会社"
              :disabled="employee.id && !isSharp()"
              :url="`companies/kv?type=${employee.companyType}`"
              v-model="employee.companyId"
            ></remote-autocomplete>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex md6 sm6 xs6>
            <v-select
              :disabled="existUsername()"
              :items="$store.state.companyType"
              item-text="text"
              item-value="value"
              label="企業区分"
              clearable
              v-model="employee.companyType"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex md6 sm6 xs6>
            <v-text-field
              :disabled="true"
              label="ユーザーID"
              v-model.trim="employee.username"
            ></v-text-field>
          </v-flex>
          <v-flex md3 sm3 v-if="employee.username" xs12>
            <v-checkbox
              label="ログイン拒否"
              v-model="employee.loginRefused"
            ></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex md6 sm6 xs12>
            <v-text-field
              :disabled="!!employee.id"
              :rules="[
                (v) => /^[A-Za-z0-9\s]+$/.test(v) || `氏名CD must be valid`,
                (v) => !v || v.length <= 255 || '長さ255桁を超えてはいけません',
              ]"
              class="mr-1"
              label="氏名CD"
              v-model.trim="employee.code"
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex md6 sm6 xs12>
            <v-text-field
              :rules="[
                (v) => !!v || ` 氏名 is required`,
                (v) => !v || v.length <= 255 || '長さ255桁を超えてはいけません',
              ]"
              label="氏名"
              v-model.trim="employee.fullName"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex md6 sm6 xs12>
            <v-text-field
              label="表示名"
              :rules="[
                (v) => !v || v.length <= 255 || '長さ255桁を超えてはいけません',
              ]"
              v-model.trim="employee.showName"
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex md6 sm6 xs12>
            <v-text-field
              :rules="[
                (v) => /^[A-Za-z0-9\s]+$/.test(v) || `英文氏名 must be valid`,
                (v) => !v || v.length <= 255 || '長さ255桁を超えてはいけません',
              ]"
              label="英文氏名"
              v-model.trim="employee.englishName"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex
            md6
            sm6
            v-if="employee.companyId && companyType === 'SHARP'"
            xs12
          >
            <remote-autocomplete
              :label="$t('app.labels.bu.name')"
              :rules="[(v) => !!v || ` 事業本部 is required`]"
              :url="`/divisions/kv?type=BU&companyId=${employee.companyId}`"
              @change="changeBu"
              v-model="employee.buId"
            />
          </v-flex>
          <v-flex
            md6
            sm6
            v-if="
              employee.companyId && companyType === 'SHARP' && employee.buId
            "
            xs12
          >
            <remote-autocomplete
              :url="`/divisions/${employee.buId}/departments`"
              label="事業部"
              v-model="employee.departmentId"
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex
            md6
            sm6
            v-if="employee.companyId && companyType === 'SHARP'"
            xs12
          >
            <remote-autocomplete
              label="BU"
              :url="`/divisions/kv?type=BUSINESS_UNIT&buId=${employee.buId}`"
              v-model="employee.businessUnitId"
            />
          </v-flex>
          <v-flex md6 sm6 xs12>
            <v-text-field
              :disabled="!!employee.id"
              :rules="[
                (v) => !!v || ` Email is required`,
                (v) =>
                  /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,10})+$/.test(v) ||
                  `E-mail must be valid`,
              ]"
              label="Email"
              v-model="employee.email"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex md6 sm6 xs12>
            <v-text-field
              :rules="[
                (v) => !v || v.length <= 255 || '長さ255桁を超えてはいけません',
              ]"
              label="外線電話番号"
              v-model="employee.outsideLineNumber"
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex md6 sm6 xs12>
            <v-text-field
              :rules="[
                (v) => !v || v.length <= 255 || '長さ255桁を超えてはいけません',
              ]"
              label="内線電話番号"
              v-model="employee.insideLineNumber"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex md12 sm6 xs12>
            <v-text-field
              :rules="[
                (v) => !v || v.length <= 255 || '長さ255桁を超えてはいけません',
              ]"
              label="役職"
              v-model="employee.position"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6 sm6 xs12>
            <date-picker
              label="申込日"
              v-model="employee.applyDate"
            ></date-picker>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex md6 sm6 xs12>
            <date-picker
              label="確認日"
              v-model="employee.confirmDate"
            ></date-picker>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6 sm6 xs12>
            <date-picker
              label="適用開始日"
              v-model="employee.startDate"
            ></date-picker>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex md6 sm6 xs12>
            <date-picker
              label="適用終了日"
              v-model="employee.endDate"
            ></date-picker>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex md6 sm6 xs12>
            <v-select
              :items="languageItems"
              :rules="[(v) => !!v || ` 语言 is required`]"
              label="语言"
              style="padding-top: 8px"
              v-model="employee.language"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
export default {
  props: ["employee"],
  data() {
    return {
      languageItems: ["en", "jp"],
      companyType: null,
      codeRule: [],
      companytype: [
        {
          text: "SHARP",
          value: "SHARP",
        },
        {
          text: "SJL",
          value: "SJL",
        },
        {
          text: "海外取引先",
          value: "PARTNER",
        },
        {
          text: "サプライヤー",
          value: "SUPPLIER",
        },
        {
          text: "生産拠点",
          value: "PRODUCTION_BASE",
        },
        {
          text: "バイヤー",
          value: "BUYER",
        },
      ],
    };
  },
  methods: {
    isSharp() {
      return this.employee.companyType === "SHARP";
    },
    changeCompany() {
      this.employee.buId = null;
      this.employee.departmentId = null;
    },
    changeBu() {
      this.employee.departmentId = null;
    },
    existUsername() {
      return this.employee.username ? true : false;
    },
  },
  watch: {
    "employee.companyType"() {},
  },
};
</script>
